import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartitionArmingComponent } from './partition-arming.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../../directives/shared.module';
import { WarningModule } from '../warning/warning.module'

@NgModule({
  declarations: [PartitionArmingComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    SharedModule,
    WarningModule,
  ],
  exports: [
    PartitionArmingComponent
  ],
  bootstrap: [PartitionArmingComponent]
})
export class PartitionArmingModule { }
